var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-2 document-info" },
    [
      _c(
        "custom-callout",
        { attrs: { "has-border": false, "has-toggle": false } },
        [
          _c("div", { staticClass: "row col-12" }, [
            _c("div", { staticClass: "row col-10" }, [
              _c("div", { staticClass: "row col-12 col-md-6" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "span",
                    { staticClass: "data-title d-block border-mobile" },
                    [_vm._v("Documento:")]
                  ),
                  _c("span", { staticClass: "font-16 color-black" }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("empty")(_vm.documentName)) + " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-6" }, [
                _vm.modelDocumentFileName
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "span",
                        { staticClass: "data-title d-block border-mobile" },
                        [_vm._v("Archivo:")]
                      ),
                      _c("p", { staticClass: "font-16 color-black" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("empty")(_vm.modelDocumentFileName)) +
                            " "
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-2 d-flex align-items-center justify-content-end"
              },
              [
                _vm.modelDocumentId
                  ? _c("action-button", {
                      staticClass: "px-1 mx-1 download-btn",
                      attrs: {
                        i: "fas fa-file-download px-2 mx-0",
                        variant: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onDownload(_vm.modelDocumentId)
                        }
                      }
                    })
                  : _vm._e(),
                _vm.canReplaceDocument &&
                _vm.modelDocumentFileName &&
                _vm.showReplaceButton &&
                !_vm.showReplaceForm
                  ? _c(
                      "action-button",
                      {
                        attrs: {
                          i: "fas fa-undo-alt",
                          variant: "outline-success ml-2"
                        },
                        on: { click: _vm.startReplace }
                      },
                      [_vm._v(" Reemplazar ")]
                    )
                  : _vm._e(),
                _vm.canAddDocument && !_vm.modelDocumentId
                  ? _c(
                      "action-button",
                      {
                        staticClass: "upload-file-button",
                        attrs: { i: "fas fa-file-plus color-green" },
                        on: { click: _vm.onAddHandler }
                      },
                      [_vm._v(" Presione aquí para anejar documento ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm.comment !== null
            ? _c("div", { staticClass: "mt-3 border-top pt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "span",
                    { staticClass: "data-title d-block border-mobile" },
                    [_vm._v(" Comentario de reemplazo: ")]
                  ),
                  _c("p", { staticClass: "font-16 color-black" }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("empty")(_vm.modelComment)) + " "
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.showReplaceForm
            ? _c("div", { staticClass: "mt-3 border-top pt-3" }, [
                _vm.requiresComment
                  ? _c("div", { staticClass: "row col-12" }, [
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("custom-text-area", {
                            attrs: {
                              "custom-error-msg": "Favor completar comentario.",
                              label: "Comentario de reemplazo:",
                              maxlength: 3000,
                              name: "comment",
                              rows: 1
                            },
                            model: {
                              value: _vm.replaceComment,
                              callback: function($$v) {
                                _vm.replaceComment = $$v
                              },
                              expression: "replaceComment"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4 d-flex align-items-center" },
                        [
                          _c(
                            "action-button",
                            {
                              attrs: {
                                i: "fas fa-file-alt",
                                variant: "outline-success ml-2"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.replaceFileInput.click()
                                }
                              }
                            },
                            [_vm._v(" Documento ")]
                          ),
                          _c("input", {
                            ref: "replaceFileInput",
                            staticClass: "form-control",
                            staticStyle: { display: "none" },
                            attrs: { accept: ".pdf", type: "file" },
                            on: { change: _vm.onReplaceFileChange }
                          }),
                          _vm.replaceFileName
                            ? _c(
                                "span",
                                { staticClass: "ml-2 text-truncate" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.replaceFileName) + " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-2 d-flex align-items-center justify-content-end"
                        },
                        [
                          _c("action-button", {
                            attrs: {
                              disabled:
                                (_vm.requiresComment && !_vm.replaceComment) ||
                                !_vm.replaceFile,
                              i: "fas fa-exchange-alt",
                              text: "Guardar",
                              variant: "success ml-2 mr-2"
                            },
                            on: { click: _vm.confirmReplace }
                          }),
                          _c(
                            "action-button",
                            {
                              staticClass: "action-button",
                              attrs: {
                                i: "fas fa-times-circle",
                                variant: "outline-danger"
                              },
                              on: { click: _vm.cancelReplace }
                            },
                            [_vm._v(" Cancelar ")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _c("input", {
            ref: `replaceDocumentHidden${_vm.documentTypeId}`,
            staticStyle: { display: "none" },
            attrs: {
              id: `replaceDocumentHidden${_vm.documentTypeId}`,
              accept: ".pdf",
              type: "file"
            },
            on: { change: _vm.updateFileChange }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }